import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';

@Component({
    selector: 'tripmakery-bot-merge-transfer-finished-stats-modal',
    templateUrl: './bot-merge-transfer-finished-stats-modal.component.html',
    styleUrls: ['./bot-merge-transfer-finished-stats-modal.component.css'],
})
export class BotMergeTransferFinishedStatsModal implements OnInit {
    stats: IBotTransferFinishedStatistics;

    constructor(private bsModalRef: BsModalRef) {}

    public close(): void {
        this.bsModalRef.hide();
    }

    ngOnInit(): void {}
}
